enum CapDonVi {
  CONG_TY = 1,
  DON_VI = 2,
}

export default CapDonVi;
